import React from 'react';
import { FontWeightType, LabelLarge, TitleLarge } from '../../../../../component/Text';

export interface QuestionAndAnswerProps {
  number:number;
  title:string;
  value:string;
}
const QuestionAndAnswer:React.FC<QuestionAndAnswerProps> = (props) => (
  <div style={{ marginBottom: 60 }}>
    <TitleLarge
      fontWeight={FontWeightType.w800}
      style={{
        fontFamily: 'NanumMyeongjo',
        textDecoration: 'underline',
        textDecorationColor: '#5F4E32',
        color: '#5F4E32',
        textUnderlineOffset: 10,
      }}
    >
      Q.
      {props.number} 
      {' '}
      {props.title}
    </TitleLarge>
    <LabelLarge style={{ color: '#333333', fontFamily: 'inter', marginTop: 16 }}>{props.value}</LabelLarge>
  </div>
);

export default QuestionAndAnswer;
